"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastMessages = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var ToastMessageContext_1 = require("./ToastMessageContext");
var Messages_1 = require("./Messages");
/**
 * @internal
 */
exports.ToastMessages = function () {
    var _a = react_1.useContext(ToastMessageContext_1.ToastMessageContext), messages = _a.messages, removeMessage = _a.removeMessage;
    if (messages.length > 0) {
        return react_1.default.createElement(Messages_1.Messages, { messages: messages, onMessageClose: removeMessage });
    }
    return null;
};
//# sourceMappingURL=ToastMessages.js.map